<!--拼接题号-->
<template>
  <div class="texts-context" :style="{
    'flex-direction': direction,
    'font-size': String(fontSize).indexOf('px') === -1 ? `${fontSize}px` : fontSize,
    'line-height': direction !== 'column' ? 'none' : '18px'
  }">
    <span :style="{ 'align-items': align, 'justify-content': justify }" v-if="texts.some(item => !item)">{{ nullText ? nullText : '--' }}</span>
    <span :style="{ 'text-align': align }" v-else :title="texts.join('.')">{{ texts.join('.')  }}</span>
  </div>
</template>
<script>
export default {
  name: "JoinTopic",
  props: {
    // 显示文本数组
    texts: {
      type: Array,
      default: () => []
    },
    // 如果显示的文本中存在空，即显示这个
    nullText: {
      type: String | Number,
      default: "--"
    },
    align: {
      type: String,
      default: "flex-start"
    },
    justify: {
      type: String,
      default: "center"
    },
    direction: {
      type: String,
      default: "column"
    },
    fontSize: {
      type: Number | String,
      default: "12px"
    }
  }
};
</script>
<style lang="scss" scoped>
.texts-context {
  font-size: $font-size-small;
  line-height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 75px;
  height: 100%;

  span {
    text-align: center;
    width: 90px;
    white-space: nowrap; /* 不换行 */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 超出部分显示为省略号 */
  }
}
</style>
